import Loader from "../../components/main/Loader";
import { saveAs } from 'file-saver';
import { useDownloadReportPresaVisioneMutation } from "../../store/services/ReportService";
import { toast } from "react-toastify";
import ReportPresaVisioneFilter from "../../components/filters/ReportPresaVisioneFilter";

export default function ReportPresaVisione() {
    const [downloadReportPresevisioni, requestReport] = useDownloadReportPresaVisioneMutation()

    const handleSetFilter = async (dataFilter: any) => {
        const mapFilter: any = {
            aziendaId: dataFilter.aziendaId.value,
            categoriaId: dataFilter.categoriaId.value,
        }
        let result: any = await downloadReportPresevisioni(mapFilter);

        if ('error' in result) {
            console.log('ERROR DOWNLOAD')
        } else {
            saveAs(result?.data, `PresaVisione_${Date.now()}.xlsx`)
            toast.success(`Report scaricato`);
        }
    }

    return(
        <>
            {requestReport.isLoading ? <Loader /> : null}
            <ReportPresaVisioneFilter methodParent={handleSetFilter} />
            {requestReport?.isError 
                ? 
                <div className="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
                    <p className="font-bold">Attenzione</p>
                    <p>Nessun risultato presente per i parametri selezionati</p>
                </div>
                : null
            }
        </>
    )
}
